import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import VueJsonp from "vue-jsonp";
import VueLazyload from "vue-lazyload";
import VueTouch from "vue-touch";
// import {sensorInit} from "./assets/common/sensorInit.js";
// sensorInit();

Vue.config.productionTip = false;
Vue.use(VueJsonp)
Vue.use(VueLazyload)
Vue.use(VueTouch)


new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount("#app");
